import type { FundraisingResponse } from '@shared/schemas';
import { all, call, getContext, put, takeLatest } from 'redux-saga/effects';

import type { FundraisingsGateway } from '../infrastructure/fundraisings.gateway';
import { fundraisingsRequested } from './fundraisings.actions';
import { fundraisingsActions } from './fundraisings.slice';

const DEFAULT_ERROR = 'Failed to load fundraisings.';

/** Best-effort human message for the failure banner (no domain error union needed). */
function toMessage(e: unknown): string {
  if (e instanceof TypeError) {
    return 'Network error; please check your connection and retry.';
  }
  return e instanceof Error && e.message ? e.message : DEFAULT_ERROR;
}

/** WORKER: fetch the fundraisings listing. All I/O via the injected gateway. */
function* fetchFundraisingsWorker() {
  const gateway: FundraisingsGateway = yield getContext('fundraisingsGateway');
  yield put(fundraisingsActions.loadStarted());
  try {
    const rows = (yield call(gateway.fetchFundraisings)) as FundraisingResponse[];
    yield put(fundraisingsActions.loadSucceeded(rows));
  } catch (e) {
    yield put(fundraisingsActions.loadFailed(toMessage(e)));
  }
}

/** WATCHERS. */
export function* fundraisingsSaga() {
  yield all([takeLatest(fundraisingsRequested.type, fetchFundraisingsWorker)]);
}
